import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * Archive listing parameter schema
 * Validates the listing ID from the URL path
 */
export const ArchiveListingParamSchema = z.object({
  id: z.string().refine(val => !isNaN(Number(val)), 'Invalid listing ID'),
});

export type ArchiveListingParam = z.infer<typeof ArchiveListingParamSchema>;

/**
 * Archive listing success response schema
 */
export const ArchiveListingSuccessResponseSchema = z.object({
  success: z.literal(true),
  archived: z.boolean(),
  status: z.number(),
});

export type ArchiveListingSuccessResponse = z.infer<typeof ArchiveListingSuccessResponseSchema>;

/**
 * Archive listing response schema (success or error)
 */
export const ArchiveListingResponseSchema = z.discriminatedUnion('success', [
  ArchiveListingSuccessResponseSchema,
  ErrorResponseSchema.extend({
    details: z.string().optional(),
  }),
]);

export type ArchiveListingResponse = z.infer<typeof ArchiveListingResponseSchema>;

/**
 * Archive listing DB record schema
 * Validates the shape of a listing record as fetched from the DB for archive operations
 */
export const ArchiveListingDbSchema = z.object({
  id: z.number(),
  status: z.number(), // 0=archived, 1=active
});
